export default {"src":"/_next/static/media/sellTradeHeaderIcon.2a68ecdd.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};